export default __webpack_public_path__ + "static/media/DinersClub.df509660.svg";